
import Vue from "vue";
import AppBrowsePagination from "../components/BrowsePagination.vue";
import AppGlobalSearch from "../components/ticket/TicketsGlobalSearch.vue";
import AppTicketDataTable from "@/components/ticket/TicketDataTable.vue";
import AppTicketQuickFilters from "@/components/ticket/TicketQuickFilters.vue";
import {Ticket} from "@/models/ticket";
import {BrowseService} from "@/services/browse-service";
import {TicketService} from "@/services/ticket-service";
import {IPaginationData} from "@/utils/browse/pagination-data";
import {setTitle, resetTitle} from "@/utils/title";
import {AdminDepartment} from "@/models/admin-department";
import {SettingsService} from "@/services/settings-service";
import {BrowseSettings} from "@/models/browse-settings";
import {AllDefaultTicketTabs, TicketTab} from "@/utils/ticket-tab";
import {TicketFilters} from "@/utils/ticket-filters";
import {SingleTaskRunner} from "@/utils/single-task-runner";
import { v4 } from "uuid";

export default Vue.extend({
	data() {
		return {
			tickets: [] as Ticket[],
			records: 0,
			selected: [] as Ticket[],
			selectedIndexes: [] as number[],
			browseSettings: [] as BrowseSettings[],
			pagination: {
				offset: 0,
				limit: 50,
				order: "this.ID",
				ascending: false,
			} as IPaginationData,
			quickFilters: new TicketFilters(),
			ready: false,
			showFilters: false,
			showGlobalSearch: false,
			currentTab: 0,
			joinedDepartments: [] as AdminDepartment[],
			unreadCount: [] as number[],
			amountOfAssignedTickets: 0,
			amountOfAttentionedTickets: 0,
			isWindowFocused: true,
			fetchRunner: null as any as SingleTaskRunner<void>,
			isFetching: false,
			fetchThreadId: "",
			isSearching: false
		};
	},
	computed: {
		tabItems(): TicketTab[] {
			let a = [
				AllDefaultTicketTabs.ALL,
				AllDefaultTicketTabs.ATTENTIONS,
				AllDefaultTicketTabs.LIKED,
				AllDefaultTicketTabs.ASSIGNED,
				AllDefaultTicketTabs.MY_TICKETS,
				//AllDefaultTicketTabs.TSV2,
				//AllDefaultTicketTabs.WFONLINE,
				AllDefaultTicketTabs.BOOKMARKED
			];
			if (this.joinedDepartments.filter((d) => d.departmentId == 2).length) {
				a.push(AllDefaultTicketTabs.SERVICEPAKKET);
			}
			return a;
		},
		tabs(): string[] {
			return this.tabItems.map((a, i) => {
				let c = "";
				if (a == AllDefaultTicketTabs.ATTENTIONS && this.amountOfAttentionedTickets > 0) {
					c = "<span class='attention-count'>" + (this.amountOfAttentionedTickets > 99 ? "!" : this.amountOfAttentionedTickets) + "</span>";
				}
				return a.title + c + this.unReadSpan(i);
			});
		},
		currentTabItem():TicketTab {
			return this.tabItems[this.currentTab];
		},
		browseName(): string {
			return `tickets/${this.tabItems[this.currentTab].name}`;
		},
		hasFilters(): boolean {
			if (parseInt(this.$route.query.companyId as string) > 0){
				return true;
			}
			if (this.currentTabItem.hasFilters(this.quickFilters)){
				console.log("Has regular filters");
				return true;
			}
			return false;
		},
	},
	watch: {
		pagination: {
			deep: true,
			handler() {
				if (!this.ready) return;
				this.fetch();
			},
		},
		async browseName() {
			console.log("browsename changed");
			this.updateQueryUrl();
			await this.fetchBrowseSettings();
			this.tabItems[this.currentTab].setFilters(this.quickFilters);
			await this.fetch();
		},
		selected: {
			deep: true,
			handler() {
				this.selectedIndexes = this.selected.map((t, i) => {
					let foundIndex = this.tickets.indexOf(t);
					if (foundIndex == -1) {
						return this.selectedIndexes[i];
					}
					return this.pagination.limit * (this.pagination.offset - 1) + foundIndex;
				});
			}
		}
	},
	methods: {
		async removeFilters() {
			this.quickFilters = new TicketFilters();
			this.currentTabItem.setFilters(this.quickFilters);
			this.$router.push(`${this.$route.path}?tab=${this.currentTab}`);
			await this.fetch();
			await this.fetchBrowseSettings();
		},
		updateQueryUrl() {
			let query = "";
			if (this.quickFilters.companyId) {
				query = `&${query}&companyId=${this.quickFilters.companyId}`;
			}
			this.$router.push(`${this.$route.path}?tab=${this.currentTab}${query}`);
		},
		async _fetch(): Promise<void> {
			let threadId = v4();
			this.fetchThreadId = threadId;
			this.isFetching = true;
			try {
				this.tickets.forEach((t) => t.deregisterSocketEvents());
				let response;
				if (this.quickFilters.companyId && this.currentTab == 0) {
					let cId = this.quickFilters.companyId;
					this.quickFilters.companyId = cId;
				}

				if(this.currentTabItem == AllDefaultTicketTabs.LIKED){
					this.quickFilters.liked = true;
				}

				response = await TicketService.getTickets(
					this.pagination,
					this.quickFilters,
					this.browseName,
				);
				if (this.fetchThreadId != threadId) {
					return;
				}

				this.tickets = response.data;
				this.records = response.records;
				this.tickets.forEach((t) => t.registerSocketEvents());
				this.isFetching = false;
				if (this.records < this.pagination.offset) {
					this.pagination.offset = 0;
					this.fetch();
				}
			} catch (err: any) {
				this.isFetching = false;
				throw err;
			}
		},
		async fetch() {
			await this.fetchRunner.run();
		},
		async openTicket(ticket?: Ticket) {
			let selected = ticket;
			if (!selected) {
				selected = this.selected[0];
				var index = this.selectedIndexes[0];
			} else {
				var index = this.pagination.offset + this.tickets.indexOf(selected);
			}
			TicketService.currentIndex = index;
			TicketService.lastUsedTab = this.currentTab;
			if (!selected.isTicketRead()) {
				await TicketService.markTicketAsRead(selected.id);
			}

			//if (this.$route.query.companyId) {
			//window.open(`https://backend.winfakt.app/ticket/${selected.id}?tab=` + this.currentTab + "&page=" + this.pagination.offset, "_blank");
			await this.$router.push(`/tickets/${selected.id}?tab=` + this.currentTab + "&page=" + this.pagination.offset);
			await this._fetch();
			this.unreadCount = await this.fechtUnreadsForAllTabs();
			/*}else{
				this.$router.push(`/ticket/${selected.id}?tab=` + this.currentTab + "&page=" + this.pagination.offset);
			}*/
		},
		async onOrder(order: { order: string; ascending: boolean }) {
			this.pagination.order = order.order;
			this.pagination.ascending = order.ascending;
		},
		async fetchBrowseSettings() {
			this.browseSettings = await BrowseService.getBrowseSettings();
			let settings = this.browseSettings.find(
				(b) => b.browse == this.browseName
			);
			if (settings) {
				this.pagination.order = settings.orderColumn;
				this.pagination.ascending = settings.orderASC;
				this.pagination.limit = settings.recordLimit;
				this.quickFilters = TicketFilters.fromBrowseSettings(settings);
			}
			if (this.$route.query.companyId) {
				this.quickFilters.companyId = parseInt(this.$route.query.companyId as string);
			}
		},
		parseQuery() {
			//let {companyId} = this.$route.query;
			//if (companyId) {
			//this.quickFilters.companyId = parseInt(companyId as string) || undefined;
			//}
		},
		async onQuickFilters(filters: TicketFilters) {
			this.quickFilters = filters;
			console.log(this.quickFilters);
			await this.fetch();
			await this.fetchBrowseSettings();
			this.unreadCount = await this.fechtUnreadsForAllTabs();
		},
		onCancelSearch() {
			this.quickFilters.searchInput = "";
			this.isSearching = false;
			this.fetch();
		},
		onQuickSearch() {
			if (this.quickFilters.searchInput) {
				this.fetch();
				this.isSearching = true;
			}
		},
		async onRefresh() {
			await this.fetch();
		},

		async fechtUnreadsForAllTabs(): Promise<number[]> {
			this.amountOfAssignedTickets = await TicketService.amountOfAssignedTickets();
			this.amountOfAttentionedTickets = await TicketService.amountOfAttentionedTickets();
			let settings = this.tabItems.map(s => this.browseSettings.find(b => b.browse == `tickets/${s.name}`)).map(b => {
				if (b) {
					return TicketFilters.fromBrowseSettings(b);
				}
				return new TicketFilters();
			});
			return TicketService.getUnreadTicketCountsPerQuery(settings);
		},

		unReadSpan(tabIndex: number): string {
			return this.unreadCount[tabIndex] > 0 ?
				"<span class='unread-count "+this.tabItems[tabIndex].name+"'>" + (this.unreadCount[tabIndex] > 99
					? "!" : this.unreadCount[tabIndex]) + "</span>" : "";
		},
		onWindowBlur() {
			this.isWindowFocused = false;
		},
		onWindowFocus() {
			if (!this.isWindowFocused) {
				this.isWindowFocused = true;
				this.fechtUnreadsForAllTabs();
			}
		},
		setPage(page:number){
			this.pagination.offset = (page - 1) * this.pagination.limit;
		}
	},
	async mounted() {
		this.fetchRunner = new SingleTaskRunner(this._fetch);
		setTitle("tickets");
		if (this.$route.query.tab) {
			this.currentTab = parseInt(this.$route.query.tab as string || "0");
		} else if (TicketService.storedFilters && TicketService.storedPagination) {
			this.pagination = TicketService.storedPagination;
			this.quickFilters = TicketService.storedFilters;
			this.currentTab = TicketService.lastUsedTab || 0;
		}
		this.joinedDepartments = await SettingsService.getJoinedDepartments();
		try {
			await this.fetchBrowseSettings();
			this.parseQuery();
		} catch (err) {
		}
		await this.fetch();
		this.ready = true;
		this.unreadCount = await this.fechtUnreadsForAllTabs();
		window.addEventListener("focus", this.onWindowFocus);
		window.addEventListener("blur", this.onWindowBlur);
	},
	destroyed() {
		resetTitle();
		this.tickets.forEach((t) => {
			t.deregisterSocketEvents();
		});
		window.removeEventListener("focus", this.onWindowFocus);
		window.removeEventListener("blur", this.onWindowBlur);
	},
	components: {
		AppTicketDataTable,
		AppBrowsePagination,
		AppTicketQuickFilters,
		AppGlobalSearch
	},
});
